import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { QuestionFilled, QuestionOutlined } from '@zeelool/icon';
import { useContext } from 'react';
import type { ComponentProps, MouseEventHandler } from 'react';
import { EPlatform } from '../../utils/enums/platform-enum';

type QuestionResponsiveProps = Omit<
  ComponentProps<typeof QuestionFilled>,
  'aria-label' | 'onClick'
> & {
  ariaLabel?: string;
  'aria-label'?: string;
  buttonClassName?: string;
  domSpm?: { 'data-spm': string };
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

// 根据设备类型返回不同的图标
export default function QuestionResponsive({
  className = 'f16',
  ariaLabel,
  'aria-label': ariaLabelProp,
  buttonClassName = '',
  onClick,
  domSpm,
  ...props
}: QuestionResponsiveProps) {
  const { deviceType } = useContext(ResponsiveContext);
  const Icon = deviceType === EPlatform.WEB ? QuestionFilled : QuestionOutlined;
  const iconClassName =
    deviceType === EPlatform.WEB
      ? `${className} f16 text-[#a3a3a3] cursor-pointer`
      : `${className} f16`;
  const icon = (
    <Icon className={iconClassName} aria-hidden {...props} {...(!onClick ? domSpm : undefined)} />
  );

  if (!onClick) {
    return icon;
  }

  return (
    <button
      {...domSpm}
      type="button"
      className={`inline-flex items-center justify-center border-0 bg-transparent p-0 w-[20px] h-[20px] ${buttonClassName}`}
      aria-label={ariaLabel || ariaLabelProp || 'More information'}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}
